import React from "react";
import Aux from "../../hoc/Auxiliary";
import Sidebar from "../../components/UI/Navigation/Sidebar/Sidebar";
import SignalRWatcher from "../../components/Signal_R/SignalRWatcher";

function Layout(props) {

  return (
    <Aux>
      <SignalRWatcher/>
      <Sidebar />
    </Aux>
  );
}



export default Layout;
